module.exports = __webpack_public_path__ + "static/media/my-pic.fe63c243.JPG";